import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetodhulecabs() {



  const cardData =
  {
    keyword: 'Pune to Dhule Cabs',
    heading: 'Sai Trupti Cabs: Pune to Dhule Cabs',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Dhule cab hire services, designed to make your inter-city journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Dhule. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Dhule convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Dhule with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Songir Fort",
    "description": "Songir Fort, located near the town of Songir in Dhule district, stands as a proud reminder of Maharashtra’s medieval valor. Perched atop a rocky hill, the fort offers panoramic views of the Tapti River basin and the surrounding countryside. Once under the rule of the Faruqi kings, it later came under the Marathas and the British. The climb to the fort passes through rugged stone paths, ancient gateways, and remnants of watchtowers. At the summit, the wind carries whispers of history, bravery, and forgotten battles. For trekkers and history enthusiasts, Songir Fort offers both adventure and a connection to Dhule’s glorious past."
  },
  {
    "title": "Thalner Fort",
    "description": "Thalner Fort, one of the oldest forts in the Khandesh region, is located on the banks of the Tapi River near Shirpur. It was once the capital of the Faruqi dynasty and played a crucial role in regional politics during the medieval period. The ruins still display traces of strong fortifications, arched gateways, and stone bastions. The serene river flowing beside the fort adds to its picturesque beauty. Historians and travelers visit Thalner to admire the architectural heritage and tranquil landscape. It stands as a silent guardian of Dhule’s ancient roots and enduring pride."
  },
  {
    "title": "Toranmal Hill Station",
    "description": "Nestled in the Satpura range, Toranmal is a hidden hill station located close to the Dhule-Nandurbar border. Known for its cool climate, lush greenery, and crystal-clear lakes, Toranmal is a paradise for nature lovers. Attractions such as Yashwant Lake, Lotus Lake, Sita Khai, and the Machhindranath Cave offer breathtaking views and peaceful retreats. During monsoon, waterfalls cascade down the hillsides, filling the air with mist and freshness. The drive from Dhule to Toranmal is scenic, winding through forests and valleys. Toranmal is a perfect getaway for travelers seeking calm, adventure, and natural beauty away from city crowds."
  },
  {
    "title": "Laling Fort",
    "description": "Laling Fort, situated about 10 km from Dhule city, is one of the district’s most significant historical landmarks. Believed to have been built during the reign of the early Faruqi kings, the fort served as a key defensive structure for the Khandesh region. Perched on a hill, it offers commanding views of the plains below. The ruins of temples, water tanks, and stone bastions still narrate tales of medieval warfare and strategy. The trek to the top is short yet rewarding, especially at sunrise. Laling Fort blends history, nature, and rustic charm — a true symbol of Dhule’s proud heritage."
  },
  {
    "title": "Aner Dam and Wildlife Sanctuary",
    "description": "Aner Dam, located near Shirpur in Dhule district, is not just an irrigation structure but also a scenic retreat surrounded by greenery and hills. The nearby Aner Wildlife Sanctuary covers over 80 square kilometers and shelters species like nilgai, chinkara, wild boar, and peacocks. The tranquil waters of the dam attract migratory birds, making it a delight for photographers and nature enthusiasts. The sanctuary’s rugged terrain and quiet trails offer opportunities for trekking and birdwatching. Aner is a perfect combination of water, wildlife, and wilderness — showcasing Dhule’s lesser-known natural beauty."
  },
  {
    "title": "Ekvira Mata Temple, Shirpur",
    "description": "Ekvira Mata Temple, located in the historic town of Shirpur, is one of the most revered religious sites in Dhule district. Dedicated to Goddess Ekvira, the temple attracts devotees throughout the year, especially during Navratri when it glows with lamps and festive energy. The temple’s hilltop location offers sweeping views of the surrounding plains and Tapi River. The rhythmic chants, the aroma of incense, and the devotion of pilgrims create a deeply spiritual atmosphere. Ekvira Mata Temple stands as a beacon of faith, purity, and local tradition in Dhule’s sacred landscape."
  },
  {
    "title": "Nakane Lake",
    "description": "Nakane Lake, located on the outskirts of Dhule city, is a serene reservoir surrounded by small hills and greenery. Built as part of a water conservation project, it has become one of the city’s favorite recreational spots. The calm waters reflect the changing colors of the sky at sunset, creating postcard-perfect moments. Locals visit for evening walks, boating, and picnics under the trees. During monsoon, the lake brims with fresh water and attracts various bird species. Nakane Lake is Dhule’s natural jewel — peaceful, refreshing, and ideal for family outings and nature photography."
  },
  {
    "title": "Bhamer Fort and Caves",
    "description": "Bhamer Fort, located near Sakri in Dhule district, is a fascinating blend of history, religion, and natural wonder. The hill fort is dotted with ancient rock-cut caves believed to be Buddhist in origin, later adapted for Jain worship. The caves contain carvings, water cisterns, and meditation chambers, reflecting the spiritual significance of the site. Climbing to the fort’s top offers sweeping views of the Satpura ranges and nearby villages. The site’s isolation and raw beauty attract trekkers, historians, and spiritual seekers alike. Bhamer Fort encapsulates Dhule’s mysterious and majestic charm."
  },
  {
    "title": "Shirpur Gold Refinery",
    "description": "Shirpur Gold Refinery, located in northern Dhule district, is one of India’s largest and most advanced gold refineries. The facility represents modern industrial progress while symbolizing the region’s economic growth. Though entry is restricted, its presence has put Shirpur on the national map as a hub of technological excellence. Visitors often explore the nearby town markets and temples, experiencing the blend of tradition and modernity. The refinery stands as a shining example of Dhule’s evolving identity — where industry and innovation meet cultural roots."
  },
  {
    "title": "Prakasha Village (Dakshin Kashi)",
    "description": "Known as Dakshin Kashi, Prakasha Village lies on the banks of the Tapi River and is one of the oldest pilgrimage sites in Maharashtra. The village is home to over 100 ancient Shiva temples, the most prominent being the Kashi Vishweshwar Mandir. During Maha Shivaratri, the village transforms into a sea of devotion as thousands of pilgrims gather for holy dips and rituals. The confluence of faith, heritage, and riverine beauty makes Prakasha a spiritually enriching experience. It’s a place where ancient chants meet the flowing river, embodying Dhule’s deep spiritual heartbeat."
  }
],



"services": [
  {
    "name": "Pune to Dhule Cabs",
    "description": "Book comfortable Pune to Dhule cabs for a safe, hassle-free journey. Choose from AC and non-AC vehicles including Sedans, SUVs, and luxury cars. Travel with experienced drivers familiar with long-distance routes, enjoy flexible pickup and drop points, and benefit from transparent pricing. Perfect for family trips, weekend getaways, group travel, or corporate journeys, with easy online booking, instant confirmation, and 24/7 support ensuring a smooth ride."
  },
  {
    "name": "Pune to Dhule Taxi Service",
    "description": "Hire a Pune to Dhule taxi for a stress-free and scenic journey. Well-maintained vehicles, courteous drivers, and flexible schedules make it ideal for tourists, business travelers, and families. One-way or round-trip options are available with transparent fare policies."
  },
  {
    "name": "Pune to Dhule Car Hire",
    "description": "Rent a car from Pune to Dhule for personalized and comfortable travel. Choose from Sedans, SUVs, and luxury vehicles with AC/non-AC options. Benefit from professional drivers, luggage assistance, flexible routes, and safe travel. Ideal for families, groups, or business trips seeking convenience and comfort."
  },
  {
    "name": "AC Cab Pune to Dhule",
    "description": "Travel comfortably with AC cab service from Pune to Dhule. Enjoy clean, air-conditioned vehicles, skilled drivers, flexible pickup points, and smooth, safe travel. Suitable for families, couples, and solo travelers looking for a relaxed long-distance journey."
  },
  {
    "name": "Non AC Cab Pune to Dhule",
    "description": "Affordable non-AC cab service from Pune to Dhule for budget-conscious travelers. Reliable drivers, well-maintained cars, and flexible pickup/drop points ensure safe, comfortable, and economical travel over long distances."
  },
  {
    "name": "Innova Cab Pune to Dhule",
    "description": "Book spacious and comfortable Innova cabs from Pune to Dhule. Ideal for families or groups, featuring AC comfort, ample legroom, luggage space, and experienced drivers. Enjoy smooth travel on highways and city roads for a stress-free journey."
  },
  {
    "name": "Ertiga Cab Pune to Dhule",
    "description": "Affordable and convenient group travel with Ertiga cabs from Pune to Dhule. AC/non-AC options, comfortable seating, luggage space, and professional drivers ensure a safe and enjoyable ride. Perfect for friends, families, or corporate groups."
  },
  {
    "name": "Luxury Cab Pune to Dhule",
    "description": "Travel in style with luxury cab services from Pune to Dhule. Premium Sedans and SUVs with elegant interiors, AC service, and professional chauffeurs make it ideal for VIP guests, business executives, or special occasions. Experience comfort, safety, and prestige throughout the journey."
  },
  {
    "name": "Affordable Cab Pune to Dhule",
    "description": "Get pocket-friendly Pune to Dhule cab services with transparent fares, AC/non-AC options, and professional drivers. Flexible timings, easy booking, and reliable service make it perfect for solo travelers, students, and small families looking for value-for-money travel."
  },
  {
    "name": "Pune to Dhule Outstation Cab",
    "description": "Reliable outstation cab service from Pune to Dhule ideal for weekend trips, sightseeing, or long stays. Choose from a variety of vehicles, enjoy AC/non-AC comfort, flexible bookings, and safe travel with experienced drivers for a hassle-free interstate journey."
  },
  {
    "name": "Pune to Dhule One Way Cab",
    "description": "Book one-way cabs from Pune to Dhule at affordable rates. Point-to-point travel, clean vehicles, professional drivers, and flexible pickups make it ideal for travelers heading to Dhule without return plans."
  },
  {
    "name": "Pune to Dhule Drop Cab",
    "description": "One-way drop cab service from Pune to Dhule with flexible timings, AC/non-AC options, and professional drivers. Enjoy a smooth, comfortable ride perfect for single transfers, business trips, or leisure travel."
  },
  {
    "name": "Corporate Cab Pune to Dhule",
    "description": "Premium corporate cab hire from Pune to Dhule with executive vehicles, professional chauffeurs, and flexible travel schedules. Ideal for conferences, business meetings, client visits, and corporate events, offering comfort, punctuality, and reliability."
  },
  {
    "name": "Wedding Cab Pune to Dhule",
    "description": "Elegant wedding cab service from Pune to Dhule with luxury interiors, AC comfort, professional drivers, and on-time pickups. Perfect for bride/groom transfers, guest transport, and event logistics with complete reliability and style."
  },
  {
    "name": "Online Cab Booking Pune to Dhule",
    "description": "Book your Pune to Dhule cab online with instant confirmation, secure payment, and transparent fares. Choose from Sedans, Innova, and Ertiga for a convenient, stress-free journey. Ideal for last-minute travel, weekend trips, or planned travel with complete convenience."
  }
],
"tableData": [
  ["Pune to Dhule Cabs", "Pune to Dhule Taxi Service"],
  ["Pune to Dhule Car Hire", "AC Cab Pune to Dhule"],
  ["Non AC Cab Pune to Dhule", "Innova Cab Pune to Dhule"],
  ["Ertiga Cab Pune to Dhule", "Luxury Cab Pune to Dhule"],
  ["Affordable Cab Pune to Dhule", "Pune to Dhule Outstation Cab"],
  ["Pune to Dhule One Way Cab", "Pune to Dhule Drop Cab"],
  ["Online Cab Booking Pune to Dhule", "Corporate Cab Pune to Dhule"],
  ["Wedding Cab Pune to Dhule", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Dhule Cabs",
    "WhyChoosedescription": "Sai Trupti Cabs offers reliable and comfortable cab services from Pune to Dhule — perfect for family travel, business trips, or leisure journeys across Maharashtra."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get affordable and transparent fares for Pune to Dhule cabs — no hidden charges, no surge pricing, and complete value for your money."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and premium cars based on your comfort, group size, and budget for the Pune–Dhule route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained and courteous drivers are well-versed with the Pune to Dhule route, ensuring a safe, smooth, and timely travel experience."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "Enjoy convenient pickups from anywhere in Pune — airport, railway station, home, or office — and drop-offs at your preferred destination in Dhule."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "Sai Trupti Cabs maintains a fleet of clean, sanitized, and well-serviced vehicles to provide a comfortable and hygienic journey every time."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our support team is available 24/7 to assist you with booking, travel details, or route information for your Pune to Dhule cab trip."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Dhule cab easily via phone call, WhatsApp, or our website — get instant confirmation and reliable cab service without any hassle."
  }
]


























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer Pune to Dhule cab services?',
    answer: 'Yes, Sai Trupti Cabs provides safe, reliable, and affordable Pune to Dhule cab services for one way, round trips, and business or personal travel.',
  },
  {
    question: 'How can I book a Pune to Dhule cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Dhule cab through our website, mobile app, or by contacting our 24×7 customer support team for instant booking assistance.',
  },
  {
    question: 'What types of cabs are available from Pune to Dhule?',
    answer: 'We offer a range of well-maintained vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers—ideal for families, groups, and solo travelers.',
  },
  {
    question: 'Are the drivers experienced for Pune to Dhule routes?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced with the Pune–Dhule route, ensuring a comfortable and safe travel experience.',
  },
  {
    question: 'Can I book a cab for local sightseeing in and around Dhule?',
    answer: 'Of course! Sai Trupti Cabs offers local sightseeing packages in Dhule for nearby attractions like Laling Fort, Songir Fort, Aner Dam, and Toranmal Hill Station.',
  },
  {
    question: 'Is the Pune to Dhule cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs operates 24×7 Pune to Dhule cab services so you can plan your trip anytime according to your convenience.',
  },
  {
    question: 'What are the Pune to Dhule cab fares?',
    answer: 'Our Pune to Dhule cab fares start from ₹3,000 for sedans and ₹3,800–₹4,500 for SUVs or Innova Crysta, depending on your travel plan and vehicle choice.',
  },
  {
    question: 'What payment options are available for Pune to Dhule cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for a seamless and secure transaction experience.',
  },
  {
    question: 'What safety and hygiene measures are followed for Pune to Dhule cabs?',
    answer: 'All our cabs are sanitized before each ride, and our drivers follow strict hygiene and safety protocols to ensure a worry-free journey.',
  },
  {
    question: 'Is customer support available during the Pune to Dhule cab journey?',
    answer: 'Yes, Sai Trupti Cabs provides round-the-clock customer support to assist you during your Pune to Dhule trip.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ajay Patil',
    feedback: 'Excellent Pune to Dhule cab experience with Sai Trupti Cabs. The driver was very professional, and the ride was smooth and comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Priya Deshmukh',
    feedback: 'Our Pune to Dhule trip with Sai Trupti Cabs was amazing. The car was clean, the driver was polite, and we reached on time. Highly recommended!',
    rating: 5,
  },
];

























































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Dhule Cab Service",
  "image": "https://saitrupticabs.com/assets/images/pune-to-dhule-cab.jpg",
  "description": "Sai Trupti Cabs offers Pune to Dhule cab service with one way taxi, round trip cabs, Innova Crysta, Ertiga, sedan and SUV options. Book affordable outstation cabs with professional drivers, 24x7 service and safe, comfortable travel experience.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Pune to Dhule"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6890"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3799",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-dhule-cab-booking",
    "itemCondition": "https://schema.org/NewCondition"
  }
};







  return (
    <div>
<Helmet>
  <title>Pune to Dhule Cab Service | One Way Taxi ₹3799 | Sai Trupti Cabs</title>

  <meta 
    name="description" 
    content="Book Pune to Dhule cab at best price ₹3799 with Sai Trupti Cabs. One way taxi, round trip, Innova Crysta, Ertiga, sedan & SUV available. Safe, reliable and 24x7 cab service for outstation travel." 
  />

  <meta 
    name="keywords" 
    content="pune to dhule cab, pune to dhule taxi, pune to dhule cab service, pune to dhule one way cab, pune to dhule taxi fare, pune to dhule innova crysta, pune to dhule ertiga cab, pune to dhule sedan cab, cheap pune to dhule cab, best cab service pune to dhule, pune to dhule drop taxi, pune to dhule round trip cab, outstation cab pune to dhule, pune to dhule online cab booking" 
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/73.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetodhulecabs;